// rm app-engine/src/config/version.ts && ln shared/config/version.ts app-engine/src/config/version.ts && rm webapp/src/config/version.ts && ln shared/config/version.ts webapp/src/config/version.ts
export const VERSION = "2.8.14";
// ---
// v2.8.14
// Correction de bugs
